/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-curly-brace-presence */

import React from "react";

function LinkSpanTag({ href, className, name, iconUp, iconSpanClass, spanUp }) {
  return (
    <a href={href} className={`${className || ""}`}>
      <span className={iconSpanClass}>
        {spanUp && <span className={spanUp} />}
        {iconUp && <i className={iconUp} />}
      </span>
      <span className="menu-title">{name}</span>
    </a>
  );
}
export default LinkSpanTag;
